import { render, staticRenderFns } from "./EaseAccess.vue?vue&type=template&id=23ea6298&scoped=true"
import script from "./EaseAccess.vue?vue&type=script&lang=js"
export * from "./EaseAccess.vue?vue&type=script&lang=js"
import style0 from "./EaseAccess.vue?vue&type=style&index=0&id=23ea6298&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ea6298",
  null
  
)

export default component.exports